import { SLTXFormatRootFileVariantComposition } from '../../fileFormats/sltx/sltx';

export class TreeOptionSelection {
  groupID : number = 0;
  optionID : number = 0;
}
// This represents a list of selections in the tree
export type TreeOptionSelections = TreeOptionSelection[];

export function buildTreeOptionSelections(
  variantFileComposition : SLTXFormatRootFileVariantComposition[],
) : TreeOptionSelections {
  return variantFileComposition.map((composition) => ({
    groupID: composition.groupId,
    optionID: composition.optionId,
  }));
}

/* DEPRECATED - Use URLEncodeTreeSelections */
export function treeSelectionsToBase64(treeSelections: TreeOptionSelections): string {

  // Get an array of the options, in the smallest size possible
  const arrOptions = treeSelections.map((variant) => {
    return `${variant.groupID}-${variant.optionID}`;
  });

  // Join the strings and put a ';' in between
  const str = arrOptions.join(';');

  // Convert the string to a base64 string
  return btoa(str);
}

/* DEPRECATED - Use URLDecodeTreeSelections */
export function base64ToTreeSelections(base64: string): TreeOptionSelections {

  // Convert the base64 string to a normal string
  const regularString = atob(base64);

  // Split the string into an array of strings
  const arr = regularString.split(';');

  // Convert the array of strings into an array of objects
  const arrObjects = arr.map((str) => {
    const [groupID, optionID] = str.split('-');
    return {
      groupID: Number.parseInt(groupID, 10),
      optionID: Number.parseInt(optionID, 10),
    };
  });

  return arrObjects;
}

export function URLEncodeTreeSelections(treeSelections: TreeOptionSelections): string {

  // Get an array of the options, in the smallest size possible
  const arrOptions = treeSelections.map((variant) => {
    return `${variant.groupID}-${variant.optionID}`;
  });

  // Join the strings and put a '_' in between
  const str = arrOptions.join('_');

  // Call URL Encode with the tree selections
  return encodeURIComponent(str);
}

export function URLDecodeTreeSelections(urlEncoded : string) : TreeOptionSelections {
  // Convert the base64 string to a normal string
  const regularString = decodeURIComponent(urlEncoded);

  // Split the string into an array of strings
  const arr = regularString.split('_');

  // Convert the array of strings into an array of objects
  const arrObjects: TreeOptionSelections = [];
  arr.forEach((str) => {
    if (str.length > 0) {
      const [groupID, optionID] = str.split('-');
      const iGroupID = Number.parseInt(groupID, 10);
      const iOptionID = Number.parseInt(optionID, 10);
      if (!Number.isNaN(iGroupID) && !Number.isNaN(iOptionID)) {
        arrObjects.push({ groupID: iGroupID, optionID: iOptionID });
      }
    }
  });

  return arrObjects;
}
